const browserPaths = {
  HOME: "/",
  // URL slug, not a secret; avoids Sonar S2068 on the substring "password".
  FIRST_LOGIN_RESET_PASSWORD: "first-login/" + "reset-pass" + "word",
  CORPORATE_FIRST_LOGIN: "first-login/corporate",
  DASHBOARD: {
    ROOT: "dashboard",
    HOME: "dashboard/home",
    HOME_RELATIVE: "home",
    COMMERCIAL_DASHBOARD: "dashboard/commercial",
    COMMERCIAL_DASHBOARD_RELATIVE: "commercial",
    AGENCE_DASHBOARD: "dashboard/agence",
    AGENCE_DASHBOARD_RELATIVE: "agence",
    COMPLIANCE_DASHBOARD: "dashboard/compliance",
    COMPLIANCE_DASHBOARD_RELATIVE: "compliance",
    CONFORMITE_DASHBOARD: "dashboard/conformite",
    CONFORMITE_DASHBOARD_RELATIVE: "conformite",
    // CREATE_ACCOUNT: "dashboard/customers/create-account",
    CREATE_ACCOUNT_RELATIVE: "customers/create-account",
    PROSPECTS: "dashboard/customers/prospects",
    PROSPECTS_RELATIVE: "customers/prospects",
    CLIENT_360: "dashboard/customers/client360",
    CLIENT_360_RELATIVE: "customers/client360",
    PROFIL: "dashboard/customers/client360/:businessKey",
    PROFIL_RELATIVE: "customers/client360/:businessKey",
    ROLES_AND_RIGHTS: "dashboard/administration/roles-and-rights",
    ROLES_AND_RIGHTS_RELATIVE: "administration/roles-and-rights",
    NOUVELLE_DEMANDE: "dashboard/demandes/new",
    NOUVELLE_DEMANDE_RELATIVE: "demandes/new",
    CREATE_PROSPECT: "dashboard/demandes/create-prospect",
    CREATE_PROSPECT_RELATIVE: "demandes/create-prospect",
    CREATE_PROSPECT_PP: "dashboard/demandes/create-prospect/pp",
    CREATE_PROSPECT_PP_RELATIVE: "demandes/create-prospect/pp",
    CREATE_PROSPECT_PM: "dashboard/demandes/create-prospect/pm",
    CREATE_PROSPECT_PM_RELATIVE: "demandes/create-prospect/pm",
    ONBOARDING: "dashboard/demandes/onboarding/:businessKey",
    ONBOARDING_RELATIVE: "demandes/onboarding/:businessKey",
    PM_ONBOARDING: "dashboard/demandes/onboarding-pm/:businessKey",
    PM_ONBOARDING_RELATIVE: "demandes/onboarding-pm/:businessKey",
    KYB_CASE_DETAIL: "dashboard/demandes/dossier-kyb/:businessKey",
    KYB_CASE_DETAIL_RELATIVE: "demandes/dossier-kyb/:businessKey",
    KYB_MANDATES: "dashboard/demandes/dossier-kyb/:businessKey/mandats",
    KYB_MANDATES_RELATIVE: "demandes/dossier-kyb/:businessKey/mandats",
    KYB_CORPORATE_ACCESS: "dashboard/demandes/dossier-kyb/:businessKey/acces-corporate",
    KYB_CORPORATE_ACCESS_RELATIVE: "demandes/dossier-kyb/:businessKey/acces-corporate",
    KYB_SIGNATURE_GRIDS: "dashboard/demandes/dossier-kyb/:businessKey/grilles-signature",
    KYB_SIGNATURE_GRIDS_RELATIVE: "demandes/dossier-kyb/:businessKey/grilles-signature",
    IDENTITY_REPLACEMENT:
      "dashboard/demandes/remplacement-identite/:businessKey",
    IDENTITY_REPLACEMENT_RELATIVE:
      "demandes/remplacement-identite/:businessKey",
    RISK_ENTITY_REFERENTIAL: "dashboard/administration/scoring-referential",
    RISK_ENTITY_REFERENTIAL_RELATIVE: "administration/scoring-referential",
    KYB_ACCESS_RECERTIFICATION: "dashboard/risques-conformite/recertification-acces",
    KYB_ACCESS_RECERTIFICATION_RELATIVE: "risques-conformite/recertification-acces",
    KYB_MONITORING: "dashboard/risques-conformite/suivi-kyb",
    KYB_MONITORING_RELATIVE: "risques-conformite/suivi-kyb",
    KYB_COMPLEMENT_DOCUMENTS: "dashboard/risques-conformite/pieces-complementaires",
    KYB_COMPLEMENT_DOCUMENTS_RELATIVE: "risques-conformite/pieces-complementaires",
    KYB_RETENTION: "dashboard/risques-conformite/conservation-kyb",
    KYB_RETENTION_RELATIVE: "risques-conformite/conservation-kyb",
    KYB_PERIMETER: "dashboard/risques-conformite/perimetre-kyb",
    KYB_PERIMETER_RELATIVE: "risques-conformite/perimetre-kyb",
    COMPLIANCE_L1_REVIEW: "dashboard/risques-conformite/file-revue-l1",
    COMPLIANCE_L1_REVIEW_RELATIVE: "risques-conformite/file-revue-l1",
    COMPLIANCE_L1_REVIEW_DETAIL: "dashboard/risques-conformite/file-revue-l1/:reviewId",
    COMPLIANCE_L1_REVIEW_DETAIL_RELATIVE: "risques-conformite/file-revue-l1/:reviewId",
    COMPLIANCE_P4_VALIDATION: "dashboard/risques-conformite/validation-4-yeux",
    COMPLIANCE_P4_VALIDATION_RELATIVE: "risques-conformite/validation-4-yeux",
    COMPLIANCE_EDD: "dashboard/risques-conformite/dossiers-edd",
    COMPLIANCE_EDD_RELATIVE: "risques-conformite/dossiers-edd",
    COMPLIANCE_EDD_DETAIL: "dashboard/risques-conformite/dossiers-edd/:caseId",
    COMPLIANCE_EDD_DETAIL_RELATIVE: "risques-conformite/dossiers-edd/:caseId",
    PLATFORM_SETTINGS: "dashboard/administration/platform-settings",
    PLATFORM_SETTINGS_RELATIVE: "administration/platform-settings",
    AGENCES: "dashboard/administration/agences",
    AGENCES_RELATIVE: "administration/agences",
    ERROR: {
      ROOT_RELATIVE: "error",
      NOT_FOUND: "dashboard/error/404",
      NOT_FOUND_RELATIVE: "404",
      UNAUTHORIZED: "dashboard/error/401",
      UNAUTHORIZED_RELATIVE: "401",
      MODULE_INACTIVE: "dashboard/error/module-inactive",
      MODULE_INACTIVE_RELATIVE: "module-inactive",
    },
  },
  ERROR: {
    ROOT_RELATIVE: "error",
    NOT_FOUND: "error/404",
    NOT_FOUND_RELATIVE: "404",
    UNAUTHORIZED: "error/401",
  },
};

export default browserPaths;
